import { ADDITIONAL_CATEGORY_LINKS } from '@/react/consts';
import { isLinkActive } from '@/react/shared/utils/helpers';

/**
 * Hook to get the current active category configuration
 */
export const useActiveCategory = () => {
  const activeCategory = ADDITIONAL_CATEGORY_LINKS.find((category) =>
    isLinkActive(category.slug)
  );

  return activeCategory || null;
};
